// extracted by mini-css-extract-plugin
export var logo = "skill-item-module--logo--xdk4h";
export var skillItem = "skill-item-module--skill-item--gR-gU";